// Este archivo maneja el registro y funcionamiento del service worker para permitir capacidades offline

// Indicador para evitar recargas infinitas
let refreshing = false;

// Función para registrar el service worker
export function register(config) {
	if ("serviceWorker" in navigator) {
		// Escuchar evento de actualización del controlador para evitar recargas múltiples
		navigator.serviceWorker.addEventListener("controllerchange", () => {
			if (!refreshing) {
				refreshing = true;
				window.location.reload();
			}
		});

		window.addEventListener("load", () => {
			const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

			// Intentar registrar el Service Worker en producción o si lo habilitamos en desarrollo
			if (process.env.NODE_ENV === "production") {
				registerValidSW(swUrl, config);
			} else {
				// En desarrollo, decidimos si desregistrarlo o registrarlo según la configuración
				if (process.env.REACT_APP_USE_SW_DEV === "true") {
					checkValidServiceWorker(swUrl, config);
				} else {
					unregister(); // Desregistrar en desarrollo por defecto
				}
			}
		});

		// Si la aplicación vuelve a estar online, verificar el estado del SW
		window.addEventListener("online", () => {
			navigator.serviceWorker.ready.then((registration) => {
				console.log(
					"Aplicación online de nuevo, verificando actualizaciones del SW"
				);
				registration.update();
			});
		});
	}
}

// Función para registrar el service worker
function registerValidSW(swUrl, config) {
	navigator.serviceWorker
		.register(swUrl)
		.then((registration) => {
			// Enviar la versión actual al service worker cuando esté listo
			const sendVersionToSW = (worker) => {
				if (worker) {
					try {
						// Importar versión de manera dinámica para evitar problemas de bundling
						import('../package.json').then((packageInfo) => {
							worker.postMessage({
								type: 'SET_CACHE_VERSION',
								version: packageInfo.version
							});
						}).catch((error) => {
							console.warn('No se pudo cargar la versión del package.json:', error);
						});
					} catch (error) {
						console.warn('Error al enviar versión al SW:', error);
					}
				}
			};

			// Enviar versión al worker activo
			if (registration.active) {
				sendVersionToSW(registration.active);
			}

			// Enviar versión al worker instalándose
			if (registration.installing) {
				registration.installing.addEventListener('statechange', () => {
					if (registration.installing.state === 'activated') {
						sendVersionToSW(registration.installing);
					}
				});
			}

			// Forzar una actualización cada vez que registramos
			registration.update();

			// Verificar si hay updates cada 60 minutos
			setInterval(() => {
				registration.update();
				console.log("Verificando actualizaciones del SW...");
			}, 60 * 60 * 1000);

			registration.onupdatefound = () => {
				const installingWorker = registration.installing;
				if (installingWorker == null) {
					return;
				}
				installingWorker.onstatechange = () => {
					if (installingWorker.state === "installed") {
						if (navigator.serviceWorker.controller) {
							// En este punto, el contenido precacheado ha sido obtenido,
							// pero el service worker anterior aún servirá el contenido
							// hasta que todas las pestañas del cliente estén cerradas.
							console.log(
								"Nuevo contenido disponible y será usado cuando todas las pestañas sean cerradas"
							);

							// Forzar actualización inmediata
							if (registration.waiting) {
								// Mostrar mensaje al usuario sobre la actualización disponible
								if (
									window.confirm(
										"Hay una nueva versión disponible. ¿Quieres actualizar ahora?"
									)
								) {
									registration.waiting.postMessage({ type: "SKIP_WAITING" });
								}
							}

							// Ejecutar callback si existe
							if (config && config.onUpdate) {
								config.onUpdate(registration);
							}
						} else {
							// En este punto, todo ha sido precacheado.
							// Es el momento perfecto para mostrar un mensaje
							// "El contenido está cacheado para uso offline."
							console.log("Contenido cacheado para uso offline");

							// Ejecutar callback si existe
							if (config && config.onSuccess) {
								config.onSuccess(registration);
							}
						}
					}
				};
			};
		})
		.catch((error) => {
			console.error("Error durante el registro del Service Worker:", error);
		});
}

// Función para verificar si el service worker puede ser encontrado.
function checkValidServiceWorker(swUrl, config) {
	// Verificar si el service worker puede ser encontrado.
	fetch(swUrl, {
		headers: { "Service-Worker": "script" },
		cache: "no-store", // Siempre obtener la versión más reciente
	})
		.then((response) => {
			// Asegurarse de que el service worker existe, y que realmente estamos obteniendo un archivo JS.
			const contentType = response.headers.get("content-type");
			if (
				response.status === 404 ||
				(contentType != null && contentType.indexOf("javascript") === -1)
			) {
				// No se encontró el service worker. Probablemente otra aplicación está usando la misma
				// puerto. Solo desregistramos, no recargamos para evitar ciclos
				navigator.serviceWorker.ready.then((registration) => {
					registration.unregister().then(() => {
						console.log("Service Worker no encontrado o no válido");
					});
				});
			} else {
				// Service worker encontrado. Proceder normalmente.
				registerValidSW(swUrl, config);
			}
		})
		.catch(() => {
			console.log(
				"No se encontró conexión a internet. La app está funcionando en modo offline."
			);

			// Verificamos si ya hay un SW activo para mantenerlo
			navigator.serviceWorker.ready
				.then((registration) => {
					console.log("Service Worker ya registrado está disponible offline");
				})
				.catch((error) => {
					console.log("No hay Service Worker disponible offline");
				});
		});
}

// Función para desregistrar el service worker
export function unregister() {
	if ("serviceWorker" in navigator) {
		navigator.serviceWorker.ready
			.then((registration) => {
				registration.unregister();
				console.log("Service Worker desregistrado con éxito");
			})
			.catch((error) => {
				console.error("Error al desregistrar el service worker:", error);
			});
	}
}
